(function(){
  'use strict';

  angular
    .module('app.blog', [

    ])

})();
